import type { ReactNode } from "react";

interface StepShellProps {
  title: string;
  helpText?: string;
  children: ReactNode;
  onBack?: () => void;
  onNext?: () => void;
  nextLabel?: string;
  nextDisabled?: boolean;
  showBack?: boolean;
  showNext?: boolean;
}

/**
 * Shared per-step layout: heading, optional help text, the step's own
 * content, then a sticky back/next control row. Every step in the flow
 * renders through this so the navigation affordance never moves around.
 */
export function StepShell({
  title,
  helpText,
  children,
  onBack,
  onNext,
  nextLabel = "Next",
  nextDisabled = false,
  showBack = true,
  showNext = true
}: StepShellProps) {
  return (
    <section className="step" aria-labelledby="step-heading">
      <div className="step__content">
        <h1 id="step-heading" className="step__title">
          {title}
        </h1>
        {helpText ? <p className="step__help">{helpText}</p> : null}
        <div className="step__body">{children}</div>
      </div>
      <div className="step__nav">
        {showBack ? (
          <button type="button" className="btn btn--ghost" onClick={onBack}>
            <span aria-hidden="true">←</span> Back
          </button>
        ) : (
          <span />
        )}
        {showNext ? (
          <button type="button" className="btn btn--primary" onClick={onNext} disabled={nextDisabled}>
            {nextLabel} <span aria-hidden="true">→</span>
          </button>
        ) : null}
      </div>
    </section>
  );
}
